import * as React from "react"

import { CompactHeaderSlotProvider } from "@/components/compact-header-slot"
import { UtilityBarPageChromeProvider } from "@/components/utility-bar-page-chrome"
import { WhatsNewProvider } from "@/components/product-home/product-home-parts"
import { WhatsNewSheetProvider } from "@/components/whats-new-sheet-context"
import { AskLeoProvider } from "@/components/ask-leo-context"
import { KeyMetricsAskLeoBridge } from "@/components/key-metrics-ask-leo-bridge"
import { LeoAmbienceProvider } from "@/components/leo-ambience-context"
import {
  CommandMenuProvider,
} from "@/contexts/command-menu-context"
import type { CommandMenuConfig } from "@/lib/command-menu-config"
import { ChartVariantProvider } from "@/contexts/chart-variant-context"
import { DashboardViewProvider } from "@/contexts/dashboard-view-context"
import { ShellLayoutProvider } from "@/contexts/shell-layout-context"
import { SystemBannerProvider } from "@/contexts/system-banner-context"

export function AppShellContextProviders({
  commandMenuConfig,
  children,
}: {
  commandMenuConfig: CommandMenuConfig
  children: React.ReactNode
}) {
  return (
    <DashboardViewProvider>
      <ChartVariantProvider>
        <AskLeoProvider>
          <LeoAmbienceProvider>
            <KeyMetricsAskLeoBridge>
              <SystemBannerProvider>
                <ShellLayoutProvider>
                  <CommandMenuProvider value={commandMenuConfig}>
                    <WhatsNewProvider>
                      <WhatsNewSheetProvider>
                        <CompactHeaderSlotProvider>
                          <UtilityBarPageChromeProvider>
                            {children}
                          </UtilityBarPageChromeProvider>
                        </CompactHeaderSlotProvider>
                      </WhatsNewSheetProvider>
                    </WhatsNewProvider>
                  </CommandMenuProvider>
                </ShellLayoutProvider>
              </SystemBannerProvider>
            </KeyMetricsAskLeoBridge>
          </LeoAmbienceProvider>
        </AskLeoProvider>
      </ChartVariantProvider>
    </DashboardViewProvider>
  )
}
